import { render, staticRenderFns } from "./productListAddNew.vue?vue&type=template&id=8197ef18&"
import script from "./productListAddNew.vue?vue&type=script&lang=js&"
export * from "./productListAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports